/* tslint:disable */
/* eslint-disable */
/**
 * GateHouse AIS REST interface
 * AIS system for monitoring vessel traffic. Commercial WebService. Contact GateHouse support for more information.
 *
 * The version of the OpenAPI document: 0.2.2
 * Contact: support@gatehouse.dk
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * GeoJSON object containing a position along with a timestamp and optionally "cog", "sog".  Based on http://geojson.org/ and https://github.com/dret/GeoJSON-X. Extensions defined are time (timestamp in ISO format, cog (Course Over Ground in degrees 0..360), sog (Speed Over Ground in knots).  Please notice extensions in coordinates can be both numbers and string (time)
 * @export
 * @interface PositionX
 */
export interface PositionX {
    /**
     * 
     * @type {Array<string>}
     * @memberof PositionX
     */
    extensions?: Array<string>;
    /**
     * 
     * @type {Array<number>}
     * @memberof PositionX
     */
    coordinates?: Array<number>;
    /**
     * 
     * @type {string}
     * @memberof PositionX
     */
    type?: PositionXTypeEnum;
}


/**
 * @export
 */
export const PositionXTypeEnum = {
    Point: 'Point'
} as const;
export type PositionXTypeEnum = typeof PositionXTypeEnum[keyof typeof PositionXTypeEnum];


/**
 * Check if a given object implements the PositionX interface.
 */
export function instanceOfPositionX(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function PositionXFromJSON(json: any): PositionX {
    return PositionXFromJSONTyped(json, false);
}

export function PositionXFromJSONTyped(json: any, ignoreDiscriminator: boolean): PositionX {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'extensions': !exists(json, 'extensions') ? undefined : json['extensions'],
        'coordinates': !exists(json, 'coordinates') ? undefined : json['coordinates'],
        'type': !exists(json, 'type') ? undefined : json['type'],
    };
}

export function PositionXToJSON(value?: PositionX | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'extensions': value.extensions,
        'coordinates': value.coordinates,
        'type': value.type,
    };
}

